import React from 'react'
import ToolbarButtonStyle from './css/ToolbarButtonStyle'

function ToolbarButton(props) {
  return (
    <React.Fragment>
      <div className='action-buttons-container'>
        { props.children }
      </div>
      <ToolbarButtonStyle />
    </React.Fragment>
  )
}

export default React.memo(ToolbarButton)
